import { render, staticRenderFns } from "./StorybookBetaBanner.vue?vue&type=template&id=081c1876&scoped=true&"
import script from "./StorybookBetaBanner.vue?vue&type=script&lang=js&"
export * from "./StorybookBetaBanner.vue?vue&type=script&lang=js&"
import style0 from "./StorybookBetaBanner.vue?vue&type=style&index=0&id=081c1876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c1876",
  null
  
)

export default component.exports